import { swapEnum } from './swapEnum';

export enum LocaleType {
  Source = 'source',
  Armenian = 'hy-AM',
  Azerbaijani = 'az-AZ',
  Belarusian = 'be-BY',
  Croatian = 'hr-HR',
  Czech = 'cs-CZ',
  English = 'en-US',
  Estonian = 'et-EE',
  French = 'fr-FR',
  Georgian = 'ka-GE',
  Greek = 'el-GR',
  Hungarian = 'hu-HU',
  Kazakh = 'kk-KZ',
  Lithuanian = 'lt-LT',
  Latvian = 'lv-LV',
  Polish = 'pl-PL',
  Portuguese = 'pt-PT',
  Romanian = 'ro-RO',
  Russian = 'ru-RU',
  Slovakian = 'sk-SK',
  Swedish = 'sv-SE',
  Ukrainian = 'uk-UA',
  Danish = 'da-DK',
  Spanish = 'es-ES',
  Finnish = 'fi-FI',
  German = 'de-DE',
  Dutch = 'nl-NL',
  Bulgarian = 'bg-BG',
  Vietnamese = 'vi-VN',
}

export const LocaleToLanguageMap = swapEnum(LocaleType);

// Map LocaleType to date-fns locale keys
export const LocaleToDateFnsLocaleMap: Record<LocaleType, string> = {
  source: 'enUS',
  [LocaleType.Armenian]: 'hy',
  [LocaleType.Azerbaijani]: 'az',
  [LocaleType.Belarusian]: 'be',
  [LocaleType.Croatian]: 'hr',
  [LocaleType.Czech]: 'cs',
  [LocaleType.English]: 'enUS',
  [LocaleType.Estonian]: 'et',
  [LocaleType.French]: 'fr',
  [LocaleType.Georgian]: 'ka',
  [LocaleType.Greek]: 'el',
  [LocaleType.Hungarian]: 'hu',
  [LocaleType.Kazakh]: 'kk',
  [LocaleType.Lithuanian]: 'lt',
  [LocaleType.Latvian]: 'lv',
  [LocaleType.Polish]: 'pl',
  [LocaleType.Portuguese]: 'pt',
  [LocaleType.Romanian]: 'ro',
  [LocaleType.Russian]: 'ru',
  [LocaleType.Slovakian]: 'sk',
  [LocaleType.Swedish]: 'sv',
  [LocaleType.Ukrainian]: 'uk',
  [LocaleType.Danish]: 'da',
  [LocaleType.Spanish]: 'es',
  [LocaleType.Finnish]: 'fi',
  [LocaleType.German]: 'de',
  [LocaleType.Dutch]: 'nl',
  [LocaleType.Bulgarian]: 'bg',
  [LocaleType.Vietnamese]: 'vi',
};

export const LocaleToLocalizedLanguageMap: { [key in LocaleType]: string } = {
  source: 'Source',
  'hy-AM': 'հայ',
  'az-AZ': 'Azərbaycanca',
  'be-BY': 'Беларускай',
  'hr-HR': 'Hrvatski',
  'cs-CZ': 'Čeština',
  'en-US': 'English',
  'et-EE': 'Eesti',
  'fr-FR': 'Français',
  'ka-GE': 'ქართული',
  'el-GR': 'Ελληνικά',
  'hu-HU': 'Magyar',
  'kk-KZ': 'Қазақ',
  'lt-LT': 'Lietuvių',
  'lv-LV': 'Latviešu',
  'pl-PL': 'Polski',
  'pt-PT': 'Português',
  'ro-RO': 'Română',
  'ru-RU': 'Русский',
  'sk-SK': 'Slovenčina',
  'sv-SE': 'Svenska',
  'uk-UA': 'Українська',
  'da-DK': 'Dansk',
  'es-ES': 'Español',
  'fi-FI': 'Suomi',
  'de-DE': 'Deutsch',
  'nl-NL': 'Nederlands',
  'bg-BG': 'Български',
  'vi-VN': 'Tiếng Việt',
};
